import jsonProvider from "./json-data-provider"
import { fetchUtils } from 'react-admin';
import { BASE_URL } from "../config";

const fetchJson = (url: string, options: any = {}) => {

    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }

    const access_token = localStorage.getItem('access_token');
    options.headers.set('Authorization', `Bearer ${access_token}`);

    return fetchUtils.fetchJson(url, options).then(response => {
        const { status, json } = response;

        if (
            status === 401 &&
            json?.message === 'Token has been revoked'
        ) {
            return Promise.reject(new Error('Token revoked. Logging out...'));
        }

        return response;
    });

};

export default jsonProvider(`${BASE_URL}`, fetchJson);
